import { UpgradePromotion } from "common/elements";
import { UserPage } from "features/user";
import { ProjectPreview } from "features/preview";
import { Rating, Feedback } from "features/review";
import { AssistantDialog } from "features/assistant";
import { Contact, UniversalPanel } from "features/universal";
import { RestrictedFeatureDialog } from "features/subscription";
import { SmartAppBanner, PwaInstallBanner } from "features/install";
import { AppLoading } from "./AppLoading";

export const DialogPage = () => {
  return (
    <>
      <Rating />
      <Contact />
      <Feedback />
      <UserPage />
      <AppLoading />
      <AssistantDialog />
      <UniversalPanel />
      <ProjectPreview />
      <SmartAppBanner />
      <RestrictedFeatureDialog />
      <PwaInstallBanner />
      <UpgradePromotion />
    </>
  );
};
